import { useState, useContext } from 'react';
import { PasswordInput, Paper, Title, Text, Container, Button } from '@mantine/core';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '@contexts/auth-context';
import AuthModal from '@components/auth-modal';
import AuthLogo from '@components/auth-logo';
import { completeNewPassword } from '@services/authentication';
import classes from './auth-common.module.css';

interface LocationState {
  requiredAttributes: string[];
  username?: string;
}
function SetNewPassword() {
  const { cognitoUser } = useContext(AuthContext);
  const location = useLocation();
  const { requiredAttributes, username } = location.state as LocationState;
  const [password, setPassword] = useState('');
  const [confPassword, setConfPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setError('');
    if (password !== confPassword) {
      setError('Passwords do not match!');
      return;
    }

    if (!cognitoUser) {
      throw new Error('Missing required cognitoUser');
    }
    completeNewPassword(cognitoUser, requiredAttributes, password)
      .then(() => {
        setSuccess(true);
      })
      .catch((err) => {
        setError((err as Error)?.message || 'An error occurred');
      });
  };

  return (
    <Container size={420} my={40}>
      <AuthLogo />
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <Title ta="center" order={2} className={classes.title}>
          New Password Required
        </Title>
        <Text ta="center" c="dimmed" size="sm" mt={5} mb={30}>
          Please set a new password to continue.
        </Text>
        <PasswordInput
          label="Password"
          placeholder="Your password"
          required
          mt="md"
          onChange={(e) => setPassword(e.target.value)}
        />
        <PasswordInput
          label="Confirm Password"
          placeholder="Your password"
          required
          mt="md"
          onChange={(e) => setConfPassword(e.target.value)}
        />
        <Button fullWidth mt="xl" onClick={(event) => handleClick(event)}>
          Set Password
        </Button>
        {error && (
          <Text c="red" pt={20}>
            {error}
          </Text>
        )}
      </Paper>
      <AuthModal
        opened={success}
        title="Success"
        message="Your password has been updated. You can now login using your new password"
        navTo="/login"
        state={{ username: username || '' }}
      />
    </Container>
  );
}

export default SetNewPassword;
